import { locales } from '@americanexpress/conditional-features';

const {
  EN_US,
  EN_GB,
  EN_AU,
  EN_CA,
  EN_NZ,
  ES_ES,
  ES_MX,
  FR_CA,
  FR_FR,
  IT_IT,
  NL_NL,
  SV_SE,
  EN_HK,
  EN_SG,
  ZH_HK,
} = locales;

export const VACATION_RENTALS_SUPPORTED_LOCALES = [EN_US];
export const CRUISES_SUPPORTED_LOCALES = [EN_US];
export const PACKAGES_SUPPORTED_LOCALES = [
  EN_GB,
  EN_AU,
  EN_CA,
  EN_NZ,
  ES_ES,
  ES_MX,
  FR_CA,
  FR_FR,
  IT_IT,
  NL_NL,
  SV_SE,
  EN_HK,
  EN_SG,
  ZH_HK,
];
